"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _axios = _interopRequireDefault(require("axios"));
var _logrocket = _interopRequireDefault(require("logrocket"));
var _reactHelmet = require("react-helmet");
var _semanticUiReact = require("semantic-ui-react");
var _RequestEditModal = _interopRequireDefault(require("./components/RequestEditModal"));
var _PublishModal = _interopRequireDefault(require("./components/PublishModal"));
var _InitialModal = _interopRequireDefault(require("./components/InitialModal"));
require("./style/PublishBanner.css");
function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var PublishBanner = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(PublishBanner, _React$Component);
  var _super = _createSuper(PublishBanner);
  function PublishBanner(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, PublishBanner);
    _this = _super.call(this, props);
    _this.state = {
      showRequestEditModal: null,
      showPublishModal: null,
      showBanner: props.defaultShowBanner,
      toShow: true,
      showInitialModal: false,
      checkedOut: false
    };
    _this.onCartClick = _this.onCartClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onMinimizeClick = _this.onMinimizeClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.needsToPay = _this.needsToPay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleRequestClose = _this.handleRequestClose.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePublishClose = _this.handlePublishClose.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleRequestOpen = _this.handleRequestOpen.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePublishOpen = _this.handlePublishOpen.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleInitialClose = _this.handleInitialClose.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onCheckoutCompleted = _this.onCheckoutCompleted.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setInitialModalTimer = _this.setInitialModalTimer.bind((0, _assertThisInitialized2["default"])(_this));
    _this.openInitialModal = _this.openInitialModal.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(PublishBanner, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var business, name, status;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                business = this.props.business;
                name = business.name;
                _logrocket["default"].init('abqepz/fisherman-websites');
                _logrocket["default"].identify(name);
                _context.next = 6;
                return this.needsToPay();
              case 6:
                status = _context.sent;
                this.setState({
                  toShow: status
                }, this.setInitialModalTimer);
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "onMinimizeClick",
    value: function onMinimizeClick() {
      this.setState({
        showBanner: false
      });
    }
  }, {
    key: "onCartClick",
    value: function onCartClick() {
      this.setState({
        showBanner: true
      });
    }
  }, {
    key: "onCheckoutCompleted",
    value: function onCheckoutCompleted() {
      this.setState({
        checkedOut: true
      });
    }
  }, {
    key: "setInitialModalTimer",
    value: function setInitialModalTimer() {
      setTimeout(this.openInitialModal, 15000);
    }
  }, {
    key: "openInitialModal",
    value: function openInitialModal() {
      this.setState({
        showInitialModal: true
      });
    }
  }, {
    key: "handlePublishClose",
    value: function handlePublishClose() {
      var _this2 = this;
      var checkedOut = this.state.checkedOut;
      this.setState({
        showPublishModal: false
      }, function () {
        if (checkedOut) {
          _this2.setState({
            toShow: false
          });
        }
      });
    }
  }, {
    key: "handleRequestOpen",
    value: function handleRequestOpen() {
      this.setState({
        showRequestEditModal: true,
        showInitialModal: false
      });
    }
  }, {
    key: "handlePublishOpen",
    value: function handlePublishOpen() {
      this.setState({
        showPublishModal: true,
        showInitialModal: false
      });
    }
  }, {
    key: "handleRequestClose",
    value: function handleRequestClose() {
      this.setState({
        showRequestEditModal: false
      });
    }
  }, {
    key: "handleInitialClose",
    value: function handleInitialClose() {
      this.setState({
        showInitialModal: false
      });
    }
  }, {
    key: "needsToPay",
    value: function () {
      var _needsToPay = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var business, url, headers, resp, status, data;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                business = this.props.business;
                url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
                headers = {
                  'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY
                };
                _context2.prev = 3;
                _context2.next = 6;
                return _axios["default"].get("".concat(url, "businesses/").concat(business.type, "s/").concat(business.id, "/subscriptions/"), {
                  headers: headers
                });
              case 6:
                resp = _context2.sent;
                status = resp.status, data = resp.data;
                if (!(status === 404)) {
                  _context2.next = 10;
                  break;
                }
                return _context2.abrupt("return", false);
              case 10:
                return _context2.abrupt("return", data.stripe_data == null);
              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](3);
                return _context2.abrupt("return", true);
              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 13]]);
      }));
      function needsToPay() {
        return _needsToPay.apply(this, arguments);
      }
      return needsToPay;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        business = _this$props.business,
        defaultDomain = _this$props.defaultDomain,
        enablePopup = _this$props.enablePopup,
        collectEmail = _this$props.collectEmail;
      var _this$state = this.state,
        toShow = _this$state.toShow,
        showBanner = _this$state.showBanner,
        showRequestEditModal = _this$state.showRequestEditModal,
        showPublishModal = _this$state.showPublishModal,
        checkedOut = _this$state.checkedOut,
        showInitialModal = _this$state.showInitialModal;
      return toShow && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, enablePopup && showInitialModal && showRequestEditModal === null && showPublishModal === null && /*#__PURE__*/_react["default"].createElement(_InitialModal["default"], {
        handlePublishOpen: this.handlePublishOpen,
        handleRequestOpen: this.handleRequestOpen,
        handleInitialClose: this.handleInitialClose
      }), showBanner ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "payment-banner"
      }, /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("script", {
        src: "https://js.stripe.com/v3/"
      })), /*#__PURE__*/_react["default"].createElement(_RequestEditModal["default"], {
        showRequestEditModal: showRequestEditModal,
        handleRequestOpen: this.handleRequestOpen,
        handleRequestClose: this.handleRequestClose,
        handlePublishOpen: this.handlePublishOpen,
        handleRequestEditClose: this.handleRequestClose,
        business: business
      }), /*#__PURE__*/_react["default"].createElement(_PublishModal["default"], {
        showPublishModal: showPublishModal,
        handlePublishOpen: this.handlePublishOpen,
        handlePublishClose: this.handlePublishClose,
        onCheckoutCompleted: this.onCheckoutCompleted,
        business: business,
        defaultDomain: defaultDomain,
        checkedOut: checkedOut,
        collectEmail: collectEmail
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        id: "minimize-icon-button",
        className: "minimize-icon-container",
        onClick: this.onMinimizeClick
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        name: "close",
        className: "minimize-icon"
      }))) : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        id: "cart-icon-button",
        className: "cart-icon-container payment-publish-button",
        onClick: this.onCartClick
      }, "Sign Up"));
    }
  }]);
  return PublishBanner;
}(_react["default"].Component);
exports["default"] = PublishBanner;
PublishBanner.propTypes = {
  business: _propTypes["default"].shape({
    id: _propTypes["default"].number.isRequired,
    type: _propTypes["default"].oneOf(['restaurant', 'generic']).isRequired,
    name: _propTypes["default"].string.isRequired
  }).isRequired,
  defaultDomain: _propTypes["default"].string.isRequired,
  defaultShowBanner: _propTypes["default"].bool.isRequired,
  enablePopup: _propTypes["default"].bool,
  collectEmail: _propTypes["default"].bool
};
PublishBanner.defaultProps = {
  enablePopup: false,
  collectEmail: false
};